import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Login from '../components/Login'
import End from '../components/End'
import Ucenter from '../components/Ucenter'
import Mygift from '../components/Mygift'
import Answer from '../components/Answer'
import Share from '../components/Share'
import Rank from '../components/Rank'
import Store from '../components/Store'
import Qa from '../components/Qa'
import Info from '../components/Info'
import Review from '../components/Review'
import Menu from '../components/Menu'
import Unsub from '../components/Unsub'
import Welcome from '../components/Welcome'
import Rule from '../components/Rule'
import Myqs from '../components/Myqs'
import Tc from '../components/Tc'
import Setting from '../components/Setting'
import Contentlist from '../components/Contentlist'
import Contentdetail from '../components/Contentdetail'
import ComingSoon from '../components/comingSoon'
import Game from '../components/game'
import Error from '../components/error'
import Land from '../components/land'
import Otp from '../components/otp'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Ucenter', component: Ucenter, meta:{title:'Home'} },
    { path: '/index', name: 'Index', component: Index},
    { path: '/login', name: 'Login', component: Login, meta:{title:'login'}  },
    { path: '/end', name: 'End', component: End, meta:{title:'answerfinish'}  },
    { path: '/ucenter', name: 'Ucenter', component: Ucenter, meta:{title:'Home'}  },
    { path: '/mygift', name: 'Mygift', component: Mygift},
    { path: '/answer', name: 'Answer', component: Answer, meta:{title:'Answering Question'}  },
    { path: '/share', name: 'Share', component: Share, meta:{title:'share'}  },
    { path: '/rank', name: 'Rank', component: Rank, meta:{title:'ranking'}  },
    { path: '/store', name: 'Store', component: Store, meta:{title:'myquest'}  },
    { path: '/qa', name: 'Qa', component: Qa, meta:{title:'qa'}  },
    { path: '/info', name: 'Info', component: Info, meta:{title:'userinfo'}  },
    { path: '/review', name: 'Review', component: Review, meta:{title:'review'}  },
    { path: '/menu', name: 'Menu', component: Menu, meta:{title:'menu'} },
    { path: '/comingsoon', name: 'comingSoon', component: ComingSoon, meta:{title:'comingSoon'} },
    { path: '/game', name: 'game', component: Game, meta:{title:'game'} },
    { path: '/unsub', name: 'Unsub', component: Unsub, meta:{title:'unsubscription'}  },
    { path: '/welcome', name: 'Welcome', component: Welcome, meta:{title:'Campaigns'}  },
    { path: '/rule', name: 'Rule', component: Rule, meta:{title:'rules'}  },
    { path: '/myqs', name: 'Myqs', component: Myqs, meta:{title:'Myqs'}  },
    { path: '/tc', name: 'Tc', component: Tc, meta:{title:'T&C'}  },
    { path: '/setting', name: 'Setting', component: Setting, meta:{title:'setting'}  },
    { path: '/contentlist', name: 'Contentlist', component: Contentlist, meta:{title:'mycontent'}  },
    { path: '/contentdetail', name: 'Contentdetail', component: Contentdetail, meta:{title:'details'}  },
    { path: '/error', name: 'Error', component: Error, meta:{title:'Error'}  },
    { path: '/land', name: 'Land', component: Land, meta:{title:'Land'}  },
    { path: '/otp', name: 'Otp', component: Otp, meta:{title:'Otp'}  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js